export default __webpack_public_path__ + "static/waterfall_light-47ce3297aaadbc346571ed065ad8abae.gif";